export default {
  apiUrl: process.env.REACT_APP_BACKEND || window.location.origin + "/api/",
  version: process.env.REACT_APP_VERSION || "Mayor.Minor.Patch",
  baseName: process.env.REACT_APP_BASENAME || "",
  env: process.env.NODE_ENV,
};
